import { render, staticRenderFns } from "./QuestionsVotes.vue?vue&type=template&id=fc1a7514&scoped=true"
import script from "./QuestionsVotes.vue?vue&type=script&lang=js"
export * from "./QuestionsVotes.vue?vue&type=script&lang=js"
import style0 from "./QuestionsVotes.vue?vue&type=style&index=0&id=fc1a7514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a7514",
  null
  
)

export default component.exports